import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { ThermoboxReportFormView } from './thermobox-report-form-view';
import {
	getModesOptionsSelector,
	getIsModesLoadingSelector,
	getFormInitialValuesSelector,
	getThermoboxesOptionsSelector,
	getIsThermoboxesLoadingSelector,
	getIcepacksOptionsSelector,
	getIsIcepacksLoadingSelector,
} from '../../selectors';
import { THERMOBOX_REPORT_FORM_NAME } from '../../constants';
import { validate } from '../../utils';

const ThermoboxReportFormWrapper = ({
	thermoboxesOptions,
	isThermoboxesLoading,
	modesOptions,
	isModesLoading,
	icepacksOptions,
	isIcepacksLoading,
	isLoading,
}) => (
	<ThermoboxReportFormView
		thermoboxesOptions={thermoboxesOptions}
		isThermoboxesLoading={isThermoboxesLoading}
		modesOptions={modesOptions}
		isModesLoading={isModesLoading}
		icepacksOptions={icepacksOptions}
		isIcepacksLoading={isIcepacksLoading}
		isLoading={isLoading}
	/>
);

const withForm = reduxForm({
	form: THERMOBOX_REPORT_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(ThermoboxReportFormWrapper);

const mapStateToProps = createStructuredSelector({
	thermoboxesOptions: getThermoboxesOptionsSelector(),
	isThermoboxesLoading: getIsThermoboxesLoadingSelector(),
	modesOptions: getModesOptionsSelector(),
	isModesLoading: getIsModesLoadingSelector(),
	icepacksOptions: getIcepacksOptionsSelector(),
	isIcepacksLoading: getIsIcepacksLoadingSelector(),
	initialValues: getFormInitialValuesSelector(),
});

ThermoboxReportFormWrapper.propTypes = {
	thermoboxesOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isThermoboxesLoading: PropTypes.bool.isRequired,
	modesOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isModesLoading: PropTypes.bool.isRequired,
	icepacksOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isIcepacksLoading: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
	initialValues: PropTypes.object,
};

const ThermoboxReportForm = connect(mapStateToProps)(withForm);

export { ThermoboxReportForm };
